// eslint-disable-next-line import/prefer-default-export
export const screenshotMinxin = {
  data() {
    return {
      // 抓取截图start
      screenshot: [],
      flagScreenshot: true,
      // 抓取截图end
    };
  },
  methods: {
    // 抓取截图start
    getScreenshot(video) {
      let timer = '';
      const that = this;
      return function fn() {
        if (that.screenshot.length >= 3 && timer) {
          console.log('screenshot.length >= 3 && timer', that.screenshot.length >= 3, timer);
          clearTimeout(timer);
          return that.screenshot;
        }
        if (that.flagScreenshot) {
          that.handlerScreenshot(video);
          that.flagScreenshot = false;
        }
        timer = setTimeout(() => {
          that.handlerScreenshot(video);
        }, 500);
      };
    },
    handlerScreenshot(video) {
      const that = this;
      const canvasElement = document.createElement('canvas');
      canvasElement.width = 260;
      canvasElement.height = 300;
      canvasElement.getContext('2d').drawImage(video, 0, 0, canvasElement.width, canvasElement.height);
      canvasElement.toBlob((blob) => {
        // 创建一个File对象
        const file = new File([blob], `${that.screenshot.length + 1}.png`, { type: 'image/png' });
        if (that.screenshot.length < 3) {
          that.screenshot.push(file);
        }
        // 在这里可以进行File对象的使用或上传等操作
      }, 'image/png');
    },
    // 抓取截图end
  },
};
